<template>
  <div class="notification-todo">
    <div class="content">
      <span class="icon">
        <DepositIcon />
      </span>
      <span>
        <div class="id-title">
          <div class="title">{{ title }}</div>
          <c-tooltip placement="top" v-if="showUnreadMarker" :content="$t('notifications.markAsRead')" variant="dark">
            <div class="read-marker" @click="handleMarkAsRead">
              <svg class="dot" viewBox="0 0 10 10">
                <circle cx="5" cy="5" r="4" />
              </svg>
            </div>
          </c-tooltip>
        </div>

        <div class="description">
          {{ description }}
          <div class="id">
            <div class="id-key"> {{ $t('notifications.id') }} </div>
          </div>
          <div class="id">
            <div class="id_tag">{{ resourceId() }}</div>
          </div>
        </div>
        <div class="links" v-if="currentTab === 'TODO'">
          <div class="clickable" @click="() => { openDetails(); handleMarkAsRead(); }" :id="getElementId('todo-see_details')">
            {{ $t('notifications.seeDetails') }}
          </div>
          <div class="clickable" @click="() => dismiss(audit.id)" :id="getElementId('todo-dismiss')">
            {{ $t('notifications.clear') }}
          </div>
        </div>
        <div v-if="currentTab === 'EVENTS' && isStatusChangeEvent()">
          <div class="statusTag" :class="getPreState()">
            {{ $t('filters.statusFilter.' + getPreState()) }}
          </div>
          <span class="arrow"> -> </span>
          <div class="statusTag" :class="getPostState()">
            {{ $t('filters.statusFilter.' + getPostState()) }}
          </div>
        </div>
      </span>
    </div>
    <div class="relative-date-container">
      {{ relativeDate(audit.created_at) }}
    </div>
  </div>
</template>


<script>
import {navigateWithParam} from "@/router";
import {RouteConstants} from "@/router/routeConstants";
import {AuditResponseDto} from "@/api/paymentApi";
import DepositIcon from "@/components/icons/DepositIcon.vue";
import {notificationMixin} from "@/mixin/notificationMixin";

export default {
  name: "DepositNotif",
  components: {DepositIcon},
  mixins: [notificationMixin],
  props: {
    audit: {
      type: AuditResponseDto,
      default: null,
      required: true
    },
    currentTab: {
      type: String,
      required: true
    },
    hideAudit: {
      type: Function,
      required: true
    },
  },
  methods: {
    ...notificationMixin.methods,
    openDetails() {
      navigateWithParam(RouteConstants.DISPUTE_DETAILS, { disputeId: this.audit.resource_id }, this.$route.query);
    },
    isStatusChangeEvent() {
      const statusChangeEvents = ["DEPOSIT_SUCCEEDED", "DEPOSIT_FAILED"];
      return statusChangeEvents.includes(this.audit.event);
    },
    getPreState() {
      switch (this.audit.event) {
        case "DEPOSIT_SUCCEEDED":
        case "DEPOSIT_FAILED":
          return "PENDING";
      }
    },
    getPostState() {
      switch (this.audit.event) {
        case "DEPOSIT_SUCCEEDED":
          return "SUCCESS";
        case "DEPOSIT_FAILED":
          return "FAILED";
      }
    },
    resourceId() {
      return this.audit.event === "DEPOSIT_FAILED" || this.audit.event === "DEPOSIT_SUCCEEDED" ?
          JSON.parse(this.audit.content).settlement_id : this.audit.resource_id;
    },
  }
};
</script>

<style lang="scss">
@import 'notification-common-style.scss';
</style>